// extracted by mini-css-extract-plugin
export var modalControls = "ModalControls-module__modal-controls--ALKRr";